class ConfigurationFactory {
    configurations;

    constructor() {
        this.configurations = {
            'viewPointAnimationSpeed': ViewPointManager.setViewPointAnimationSpeed
        };
    }

    setConfiguration(key, value) {
        if (this.configurations.hasOwnProperty(key)) {
            this.configurations[key](value);
        } else {
            console.error("Configuration not found");
        }
    }
}

export default new ConfigurationFactory();
